// extracted by mini-css-extract-plugin
export default {"noHighlight":"Background_noHighlight__oyh31","mainBox":"Background_mainBox__TB8Ej"};